import JQueryView, { on } from '@/common/views/jqueryView';

export default class SearchView extends JQueryView {
  constructor() {
    super('#search_view');
  }

  @on({ event: 'click', selector: '.open' })
  onClickOpen(event: JQuery.ClickEvent) {
    $(event.currentTarget)
      .closest('.ir-detail')
      .find('.status')
      .html('<span class="text-darkgray">既読</span>');
  }
}
